export default function() {}



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/d3-shape/src/noop.js
// module id = 440
// module chunks = 0